export default function MaterialRow({ name, href, isLast = false }) {
  const containerClasses = `
    flex flex-col gap-2 items-start
    md:flex-row md:items-center md:gap-8 md:justify-between
    py-6 border-t ${isLast ? 'border-b' : ''} border-gray-200 
    px-2 transition-shadow hover:shadow-y dark:hover:glow-y hover:cursor-none opacity-100
  `;


  const truePathHref = href ? `/downloads/${href}` : '';
  return (
    <div className={containerClasses}>
      <div className="text-xs sm:text-base md:text-lg text-black-muted dark:text-white-muted">
        {truePathHref ? (
          <a
            href={truePathHref}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline hover:text-accent transition-colors"
          >
            {name}
          </a>
        ) : (
          name
        )}
      </div>
      {
        href ? (
          <a
            href={truePathHref}
            className="font-subheading text-base text-xs px-4 py-1 border border-gray-300 rounded-none hover:border-gray-400 transition-colors"
            download={(() => {
              try {
                if (!href) return 'download.pdf';

                // Extract pathname basename without query/hash
                const pathPart = href.split('?')[0].split('#')[0];
                const base = pathPart.split('/').pop() || '';

                // helper to detect ext
                const getExt = (s) => {
                  const m = /\.([a-z0-9]{1,8})$/i.exec(s || '');
                  return m ? m[1].toLowerCase() : null;
                };

                // 1) prefer extension from href basename
                const extFromHref = getExt(base);
                if (extFromHref) return base;

                // 2) try to infer from provided display name
                const extFromName = getExt(name || '');
                if (extFromName) {
                  // sanitize name to a safe filename
                  const safe = (name || 'download').replace(/[^a-z0-9._-]/gi, '_');
                  return safe;
                }

                // 3) fallback: use basename (if present) with .pdf
                if (base) return `${base}.pdf`;

                // final fallback
                return 'download.pdf';
              } catch (e) {
                return 'download.pdf';
              }
            })()}
          >
            <p className="text-xs sm:text-base md:text-lg">Download</p>
          </a>
        ) : (
          <a className="font-subheading text-base text-xs sm:text-base md:text-lg px-4 py-1 border border-gray-300 rounded-none transition-colors opacity-60 pointer-events-none">
            <p>Coming Soon</p>
          </a>
        )
      }
    </div>
  );
}
